<template>
	<div class="customer-info-box1">
		<div class="fx-title">
			<p>订单信息</p>
		</div>
		<div class="info-box" v-if="!afterSaleId">
			<div class="customer-box"><span class="info-title">客户类别：</span>
				<div>
					<el-select
						class="info-select"
						v-model="ccid"
						filterable
						clearable
						placeholder="请选择客户类别"
						@change="setCustomer"
						:popper-append-to-body="true">
						<el-option
							v-for="item in customerList"
							:key="item.ccid"
							:label="item.ccname"
							:value="item.ccid">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="customer-box"><span class="info-title">客户名称：</span>
				<div>
					<el-select
						class="info-select"
						:class="isError? 'is-error' : ''"
						v-model="value"
						filterable
						remote
						clearable
						placeholder="请输入客户名称/手机号/注册号"
						@change="setValue"
						:remote-method="remoteMethod"
						:loading="loading"
						:popper-append-to-body="true">
						<el-option
							v-for="item in options"
							:key="item.id"
							:label="item.name + '(手机号:' + item.tel + ',注册号:' + item.syscode + ')'"
							:value="item.id">
						</el-option>
					</el-select>
					<div class="el-form-item__error el-form-item__error--inline" v-show="isError">
						必须选择一个客户
					</div>
				</div>
			</div>
			<div class="customer-box"><span class="info-title">处理售后订单号：</span>
				<div>
					<el-select
						class="info-select select-width"
						v-model="orderid"
						filterable
						clearable
						placeholder="请选择处理售后订单号"
						@change="setOrderid"
						:disabled="!value"
						:popper-append-to-body="true">
						<el-option
							v-for="item in orderList"
							:key="item.id"
							:label="item.orderNumber"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
				<span class="order-search" @click="findOrder" v-if="value" style="color:var(--fx-primary-color)">查找订单</span>
				<span class="order-search" v-else>查找订单</span>
			</div>
		</div>
		<div class="info-box2" v-if="afterSaleId">
			<div>售后单号: {{detailInfo.afterSaleNumer}}  <span style="margin-left:80px">售后时间: {{detailInfo.afterSaleDate}}</span></div>
			<div>客户类型: {{detailInfo.customerCategoryName}}</div>
			<div>客户名称: {{detailInfo.customerName}}</div>
			<div>处理售后订单号: <span class="info-number" @click="goOrderDetail">{{detailInfo.orderNumber}}</span></div>
		</div>
		<el-dialog
			title="查找订单"
			:visible.sync="findVisible"
			class="dialog-title"
			width="1200px"
			@close='dialogClose'
			@open='open'
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-box-row">
					<div class="filters-container">
						<div class="input-box" style="display:flex;align-items: center;">
							<span>下单时间：</span>
							<el-date-picker
								v-model="dateValue"
								:clearable="false"
								:unlink-panels='true'
								:default-time="['00:00:00', '23:59:59']"
								class="time-input"
								size="small"
								type="datetimerange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								format='yyyy-MM-dd HH:mm'
								value-format='yyyy-MM-dd HH:mm'>
							</el-date-picker>
						</div>
					</div>
					<div class="filters-container">
						<div class="input-box">
							<span>客户类别：</span>
							<el-select v-model="customerCategoryId" class="filter-input" size='small' @change="setCustomer2" clearable filterable>
								<el-option v-for="item in customerList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
							</el-select>
						</div>
					</div>
					<div class="filters-container">
						<div class="input-box">
							<span>客户名称：</span>
							<el-select v-model="customerId" class="filter-input" size='small' clearable filterable>
								<el-option v-for="item in customList" :value="item.id" :label="item.name + '(手机号:' + item.tel + ',注册号:' + item.syscode + ')'" :key="item.id"></el-option>
							</el-select>
						</div>
					</div>
					<div class="filters-container" style="position:relative">
						<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
						<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
					</div>
				</div>
				<div class="filters-box-row filters-box-row2">
					<div class="filters-container" v-show="!collapse">
						<div class="filters-container">
							<div class="input-box">
								<span>商品名称：</span>
								<el-input
									class="search-input"
									v-model="productName"
									placeholder="请输入商品名称"
									size="small"
									maxlength="50"
									@keyup.enter.native="search">
								</el-input>
							</div>
						</div>
						<div class="input-box">
							<span>订单号：</span>
							<el-input
								class="search-input"
								v-model="orderNumber"
								placeholder="请输入订单号"
								size="small"
								@keyup.enter.native="search">
							</el-input>
						</div>
						<div class="input-box">
							<span>订单状态：</span>
							<el-select v-model="orderStatus" class="filter-input cancel-select" size='small'>
								<el-option :value="-1" label="全部"></el-option>
								<el-option :value="3" label="待收货"></el-option>
								<el-option :value="4" label="已完成"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<el-table
					class="grid-content"
					:data="tableData"
					border
					max-height="450"
					@selection-change="selectionChangeHandle"
					ref="DataTable"
				>
					<el-table-column
						prop="createDate"
						label="下单时间"
						align="center">
					</el-table-column>
					<el-table-column
						prop="orderNumber"
						label="订单编号"
						align="center">
						<template slot-scope="scope">
							<div @click="goOrderDetail2(scope.row)" class="under-num">{{scope.row.orderNumber}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="orderStatus"
						label="订单状态"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.orderStatus === 3 ? '待收货' : scope.row.orderStatus === 4 ? '已完成' : ''}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="attrplanCount"
						label="订单信息"
						align="center">
						<template slot-scope="scope">
							<div>品项：{{scope.row.attrplanCount}}，数量：{{scope.row.totalQuantity}}，金额：{{scope.row.finalMoney}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="customerName"
						label="客户名称"
						align="center">
					</el-table-column>
					<el-table-column
						prop="customerCategoryName"
						label="客户类别"
						align="center">
					</el-table-column>
					<el-table-column
						prop="memo"
						label="备注"
						align="center">
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="addSingle(scope.row)">选择</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handlePageChange"
					:current-page="pagination.page"
					:page-sizes="[20,40, 60, 100]"
					:page-size="pagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'valetCInfo',
	props: {
		shopId: {
			type: String
		},
		afterSaleId: {
			type: String
		},
		detailInfo: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			},
			tableData: [],
			totalCount: 0,
			goodsName: '',
			userName: '',
			options: [],
			customerList: [],
			customList: [],
			ccid: '',
			value: '',
			buyersyscodeid: '',
			syscode: '',
			list: [],
			loading: false,
			isError: false,
			isTrue: true,
			isWaring: false,
			findVisible: false,
			dateValue: [],
			defaultDate: [],
			orderStatus: -1,
			orderid: '',
			orderList: [],
			customerCategoryId: '',
			customerId: '',
			productName: '',
			orderNumber: '',
			collapse: false
		}
	},
	watch: {
		detailInfo (val) {
			this.orderid = val.orderId
		}
	},
	created () {
		this.setDate()
	},
	mounted () {
		this.getCustomer()
		this.remoteMethod()
	},
	methods: {
		setDate () {
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			var nowDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
			// 获取30天前得日期
			var lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30)// 最后30天可以更改，意义：是获取多少天前的时间
			var lastY = lastDate.getFullYear()
			var lastM = lastDate.getMonth() + 1
			var lastD = lastDate.getDate()
			var LDate = lastY + '-' + (lastM < 10 ? '0' + lastM : lastM) + '-' + (lastD < 10 ? '0' + lastD : lastD)// 得到30天前的时间
			this.dateValue = [LDate + ' 00:00', nowDate + ' 23:59']
			this.defaultDate = [LDate + ' 00:00', nowDate + ' 23:59']
		},
		addSingle (row) {
			if (this.ccid !== row.customerCategoryId) {
				this.ccid = row.customerCategoryId
				this.options = this.customList
			}
			if (this.value !== row.customerId) {
				this.value = row.customerId
				this.getAfterOrder()
			}
			this.orderid = row.id
			row.orderMemo = row.memo
			this.$emit('setValue', this.orderid, row)
			this.findVisible = false
		},
		findOrder () {
			this.findVisible = true
		},
		selectionChangeHandle (value) {
			let giftNum = 0
			this.selectNum = value.length
			this.selectTableData = value
			let ids = value.map((item) => {
				return item.attrplanid
			})
			for (let i = 0; i < this.tableData2.length; i++) {
				if (ids.indexOf(this.tableData2[i].attrplanid) !== -1) {
					if (this.tableData2[i].giftflag) {
						giftNum++
					}
					this.tableData2[i].selected = true
					if (this.tableData2[i].itemquantity === '') {
						this.tableData2[i].itemquantity = this.tableData2[i].minbuycnt === 0 ? 1 : this.tableData2[i].minbuycnt
					}
				} else {
					this.tableData2[i].selected = false
				}
			}
			this.giftNum = giftNum
		},
		goOrderDetail () {
			let orderParams = {}
			orderParams.orderId = this.detailInfo.orderId
			orderParams.statusId = this.detailInfo.statusId
			orderParams.differ = this.detailInfo.differ
			orderParams.buypullstate = this.detailInfo.buypullstate
			switch (this.detailInfo.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = this.detailInfo.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		goOrderDetail2 (row) {
			let orderParams = {}
			orderParams.orderId = row.id
			orderParams.statusId = row.statusId
			orderParams.differ = row.differ
			orderParams.buypullstate = row.buypullstate
			switch (row.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		// search () {
		// 	let data = {
		// 		shopid: this.shopId,
		// 		syscodeid: this.buyersyscodeid,
		// 		productName: this.goodsName,
		// 		bigTypeCategory: this.bigClass,
		// 		smallTypeCategory: this.smallClass,
		// 		paramList: this.tableData,
		// 		page: this.pagination.page,
		// 		size: this.pagination.size
		// 	}
		// 	this.$store.dispatch('requestPost', {
		// 		url: `${this.$fxBaseApi.urlQIVShop}/replacorder/productlist`,
		// 		data: data
		// 	}).then(res => {
		// 		if (res.recordList === null) {
		// 			this.tableData2 = []
		// 		} else {
		// 			res.recordList.forEach(e => {
		// 				e.selected = false
		// 				e.itemquantity = ''
		// 				e.memo = ''
		// 			})
		// 			this.tableData2 = res.recordList
		// 		}
		// 		this.totalCount = res.recordCount
		// 	}).catch(error => {
		// 		this.$message.error(error.msg)
		// 	})
		// },
		clear () {
			this.productName = ''
			this.orderNumber = ''
			this.orderStatus = -1
			this.dateValue = this.defaultDate
			this.search()
		},
		open () {
			this.customerCategoryId = this.ccid
			this.customerId = this.value
			this.search()
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			if (this.checkTime()) {
				this.tableData = []
				let params = {
					beginDate: this.dateValue.length > 0 ? this.dateValue[0] : '',
					endDate: this.dateValue.length > 0 ? this.dateValue[1] : '',
					orderNumber: this.orderNumber,
					orderStatus: this.orderStatus,
					customerCategoryId: this.customerCategoryId,
					customerId: this.customerId,
					productName: this.productName,
					page: this.pagination.page,
					size: this.pagination.size
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/findOrderListForAfterSale`,
					data: params
				}).then(res => {
					if (res.result) {
						this.totalCount = res.data.recordCount
						this.tableData = res.data.recordList
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.search()
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.search()
		},
		dialogClose () {
			this.tableData = []
			this.pagination.page = 1
			// this.bigClass = ''
			// this.smallClass = ''
			// this.goodsName = ''
			// this.getsmallClass()
			// this.smallClassList = [{ shopCategoryName: '全部', id: '' }]
		},
		close () {
			this.dialogVisible = false
		},
		// 选择客户类别
		setCustomer () {
			this.value = ''
			this.orderid = ''
			this.$emit('setValue', this.value, {})
			this.remoteMethod(this.value)
		},
		// 修改客户
		setValue () {
			if (!this.value) {
				this.isError = true
			} else {
				this.isError = false
			}
			for (let i = 0; i < this.options.length; i++) {
				if (this.value === this.options[i].id) {
					this.buyersyscodeid = this.options[i].buyersyscodeid
					this.syscode = this.options[i].syscode
					this.$emit('setSyscodeid', this.buyersyscodeid)
					this.$emit('changeCus', this.options[i])
					break
				}
			}
			// this.options.forEach(item => {
			// 	if (this.value === item.id) {
			// 		this.userName = item.name
			// 	}
			// })
			this.orderid = ''
			this.getAfterOrder()
		},
		setOrderid () {
			let orderobj = {}
			this.orderList.forEach(item => {
				if (this.orderid === item.id) {
					orderobj = item
				}
			})
			this.$emit('setValue', this.orderid, orderobj)
		},
		// 售后订单号
		getAfterOrder () {
			let data = {
				beginDate: this.defaultDate[0],
				endDate: this.defaultDate[1],
				customerCategoryId: this.ccid,
				customerId: this.value
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findOrderListForAfterSale`,
				data: data
			}).then(res => {
				if (res.result) {
					this.orderList = res.data.recordList
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		// 客户类别
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customerList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		setCustomer2 () {
			this.customerId = ''
			let data = {
				keyword: '',
				shopid: this.shopId,
				ccid: this.customerCategoryId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfo4Business`,
				data: data
			}).then(res => {
				if (res.result) {
					this.customList = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		// 查询客户
		remoteMethod (query) {
			this.loading = true
			let data = {
				keyword: query,
				shopid: this.shopId,
				ccid: this.ccid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfo4Business`,
				data: data
			}).then(res => {
				if (res.result) {
					this.loading = false
					this.options = res.data
					this.customList = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.customer-info-box1 {
	padding-left: 10px
	box-sizing: border-box
	// overflow: hidden
	font-size: 14px
	margin-top: 10px
	.el-input {
		height: 30px
	}
	.fx-title {
		font-weight: 700
		margin: 20px 0 10px 0
	}
	.info-box {
		text-align: left
		&>div {
			display: flex
			align-items: flex-start
			padding-left: 14px
		}
		.address-box {
			margin-top: 10px
		}
		.info-title {
			margin-right: 10px
			margin-top: 5px;
		}
		.order-search {
			margin-top: 5px;
			text-decoration: underline
			cursor: pointer;
			margin-left: 10px
			font-size: 13px;
			color: #999;
		}
	}
	.info-box2 {
		text-align: left
		&>div {
			padding-left: 14px
			line-height: 30px
			.info-number {
				cursor :pointer;
				color: var(--fx-primary-color);
				text-decoration: underline
			}
		}
	}
	.under-num {
		cursor :pointer;
		color: var(--fx-primary-color);
		text-decoration: underline
	}
}
</style>
<style lang="stylus">
.customer-info-box1 {
	.customer-box {
		margin-bottom: 20px;
		.el-input, .el-input__inner {
			height: 30px
			width: 350px
		}
		.select-width {
			width: 308px;
			.el-input, .el-input__inner {
				width: 308px
			}
		}
		.info-select {
			.el-icon-:before{
				content: "\e6e1";
			}
			.is-focus{
				.el-icon-{
					transform: rotateZ(0)
				}
			}
		}
		.info-select.is-error {
			.el-input__inner {
				border-color: #F56C6C
			}
		}
		.el-form-item__error {
			display: block
		}
	}
	.el-dialog {
		margin-top: 10vh!important
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-pagination {
		text-align: center;
		margin-top: 10px
	}
	.filters-box-row {
		display: flex;
		padding: 10px 0 0 0;
		width :100%;
		line-height :50px;
		min-width :600px;
		box-sizing: border-box
		text-align: left
		.select-input {
			width: 125px!important;
			.el-input {
				width: 125px!important;
			}
		}
		.search-input {
			// width: 125px!important;
		}
		&.filters-box-row2 {
			padding-top: 0;
			.filters-container {
				display: flex
				flex-wrap: wrap
				.input-box {
					margin-right: 5px
				}
			}
		}
		.filters-container {
			margin-right: 5px
			.el-input {
				width: 150px
			}
			.time-input {
				width: 300px;
				margin-left: 10px;
			}
			.filter-input {
				width: 150px
			}
			.accept-input {
				width: 125px
			}
			.batch-register-btn{
				cursor :pointer;
				color: var(--fx-primary-color);
				font-size: 12px;
				margin-left: 10px;
				display: inline-block;
				width: 60px;
				height: 40px;
			}
		}
	}
	.el-input__icon {
		line-height: 30px
	}
	.el-radio {
		display: block;
		margin-bottom: 7px;
		&:first-of-type {
			margin-top: 4px
		}
	}
	.el-radio__input.is-checked+.el-radio__label {
		color: #606266;
	}
	.el-radio.is-address .el-radio__label {
		color: var(--fx-primary-color)!important;
	}
    .select-box{
        width :200px;
        margin-right :10px;
    }
    .select-box1{
        width :200px;
    }
	.input540{
		.el-input--mini{
			width:500px
		}
	}
    .el-form-item{
        margin-bottom :2px
        height :40px
    }
    .el-form-item >>> .el-form-item__content{
        text-align :left
    }
	.el-input--mini .el-input__inner {
		height: 28px;
		line-height: 28px;
	}
}
</style>
